import request from '../utils/request'
import { getToken } from '../utils/auth'

export function fetchHoroscopeList(filter) {
  return request({
    url: '/api/horoscopes',
    method: 'get',
    params: {
      filter,
      'access_token': getToken()
    }
  })
}

export function fetchHoroscope(id, filter) {
  return request({
    url: '/api/horoscopes/' + id,
    method: 'get',
    params: {
      filter,
      'access_token': getToken()
    }
  })
}

export function createHoroscope(data) {
  return request({
    url: '/api/horoscopes',
    method: 'post',
    params: {
      'access_token': getToken()
    },
    data
  })
}

export function updateHoroscope(id, data) {
  return request({
    url: '/api/horoscopes/' + id,
    method: 'patch',
    params: {
      'access_token': getToken()
    },
    data
  })
}

export function deleteHoroscope(id) {
  return request({
    url: '/api/horoscopes/' + id,
    method: 'delete',
    params: {
      'access_token': getToken()
    }
  })
}
